import {createSlice} from '@reduxjs/toolkit';
import {getTeams} from '../api/teams';

const slice = createSlice({
	name: 'teams',
	initialState: {
		teamList: undefined,
		checkedList: [],
		loading: false,
	},
	reducers: {
		teamListUpdated: (teams, action) => {
			teams.teamList = action.payload;
		},
		checkedListUpdated: (teams, action) => {
			teams.checkedList = action.payload;
		},
		setLoading: (teams, action) => {
			teams.loading = action.payload;
		},
		resetTeamsCheckedList: (teams) => {
			teams.checkedList = [];
		}
	}
});

export const {teamListUpdated, checkedListUpdated, setLoading, resetTeamsCheckedList} = slice.actions;

export default slice.reducer;

/**
 * Load teams list for a user
 * @returns {Function} - Redux thunk action
 */
export const loadTeamList = () => async (dispatch, getState) => {
	dispatch(setLoading(true));
	
	try {
		const response = await getTeams();
		dispatch(teamListUpdated(response.data));
	} catch (error) {
		dispatch(teamListUpdated([]));
		console.error('Error loading teams list:', error);
	} finally {
		dispatch(setLoading(false));
		dispatch(resetTeamsCheckedList());
	}
};


/**
 * Remove a team from the list
 * @param {Object} team - Team to remove
 * @returns {Function} - Redux thunk action
 */
export const removeTeamFromCheckedList = (team) => async (dispatch, getState) => {
	const {checkedList} = getState().teams;
	const updatedCheckedList = checkedList.filter(item => item._id !== team._id);
	dispatch(checkedListUpdated(updatedCheckedList));
};

/**
 * Add a team to the checked list
 * @param {Object} team - Team to add
 * @returns {Function} - Redux thunk action
 */
export const addTeamToCheckedList = (team) => async (dispatch, getState) => {
	const {checkedList} = getState().teams;
	const updatedCheckedList = [...checkedList, team];
	dispatch(checkedListUpdated(updatedCheckedList));
}